import Utils from '@/common/utils'
import axios from 'axios'

const headers = {
  'Content-Type': 'application/json',
  Authorization: Utils.setBaseAppToken()
}

export default class FactoringCompanyService {
  static getURL () {
    return process.env.VUE_APP_API_HOST
  }

  static async getByRFC (params) {
    const url = await this.getURL()
    const { data } = await axios.get(`${url}/api/factoringCompanyByRFC/`, { headers, params })
    return data
  }

  // Genera o actualiza el registro de paymentDays
  static async createPaymentDays (params) {
    const url = await this.getURL()
    const { data } = await axios.post(`${url}/api/client/paymentDays/`, params, { headers })
    return data
  }

  // Crea las empresas que se descargaron del sat y se vendieron facturas
  static async create (companyData) {
    const url = await this.getURL()
    const { data } = await axios.post(`${url}/api/factoringCompany/`, companyData, { headers })
    return data
  }
}
